const simuladorFolha = {
  id: "simulador-folha",
  titulo: "Simulador de Folha",
  pathModulo: "/simulacao-folha",
  icone: "Calculator",
  allowedRoles: [
    "admin",
    "rh",
    "financeiro",
    "diretor",
    "OPERACAO",
    "GESTOR_ESTRATEGICO",
    "ASSISTENTEOPERACAO",
  ],
  descricao:
    "Ferramenta de simulação da folha de pagamento: lista os colaboradores ativos/inativos com salário, cargo, modalidade e projeto, permite simular reajustes salariais e cadastrar novas contratações, e compara o impacto da folha simulada com o faturamento realizado mês a mês.",
  passoAPasso: [
    {
      titulo: "Localize um colaborador",
      texto:
        "Use o campo \"Buscar...\" para localizar por nome, e os filtros de Cargo, Modalidade (CLT, PJ ou Estagiário), Status (Ativo/Inativo) e GP para restringir a lista, ou o filtro de Projetos para ver apenas quem está alocado em determinados projetos.",
    },
    {
      titulo: "Cadastre um novo funcionário",
      texto:
        "Clique em \"Novo Funcionário\" e preencha nome, cargo, salário base e modalidade de contrato. É possível já configurar dois reajustes (R1 e R2) informando agrupamento percentual, enquadramento, mês e vigência (início/fim).",
    },
    {
      titulo: "Simule um reajuste salarial",
      texto:
        "A partir da linha do colaborador, ajuste o agrupamento percentual (de 80% a 120%) e o enquadramento (0 a 14) desejados. O simulador recalcula automaticamente o novo salário e os encargos, usando a tabela de reajuste vigente.",
    },
    {
      titulo: "Veja o detalhamento do reajuste",
      texto:
        "O botão que abre o modal \"Detalhamento de Reajuste\" mostra a tabela completa de valores por agrupamento e enquadramento, além dos encargos CLT calculados (INSS, FGTS, provisões) e dos benefícios fixos por modalidade (Flash, Clube, Gympass, Seguro de Vida, Odonto, Unimed, Mobilidade, Previdência).",
    },
    {
      titulo: "Compare com o faturamento realizado",
      texto:
        "A tela cruza o custo simulado da folha com o Faturamento Líquido e Bruto Realizado de cada mês (trazido automaticamente da planilha de faturamento), para avaliar se o impacto do reajuste é sustentável.",
    },
    {
      titulo: "Exporte os dados filtrados",
      texto:
        "Use o botão \"Exportar Arquivo\" para baixar em Excel a lista de colaboradores com o recorte de filtros aplicado no momento.",
    },
  ],
  dicas: [
    "Meses anteriores ao mês atual ficam bloqueados para simulação — isso é proposital, para não alterar retroativamente um período já fechado.",
    "Ao simular um reajuste, confira sempre o agrupamento percentual e o enquadramento juntos: os dois combinados é que definem o valor na tabela de reajuste.",
    "Use o filtro de Status \"Ativo\" (padrão da tela) para focar apenas em quem está na folha atual; mude para \"Inativo\" só quando precisar consultar histórico de desligados.",
  ],
  faq: [
    {
      pergunta: "Qual a diferença entre agrupamento e enquadramento?",
      resposta:
        "O agrupamento percentual (80% a 120%) e o enquadramento (0 a 14) são os dois eixos da tabela de reajuste salarial: juntos, eles determinam o valor de salário aplicado na simulação.",
    },
    {
      pergunta: "Os benefícios variam por modalidade de contrato?",
      resposta:
        "Sim. CLT e PJ têm o mesmo pacote de benefícios fixos (Flash, Clube, Gympass, Seguro de Vida, Odonto, Unimed, Mobilidade, Previdência); Estagiário tem um pacote reduzido (Gympass, Clube, Seguro de Vida e Mobilidade).",
    },
    {
      pergunta: "A simulação altera a folha de pagamento real?",
      resposta:
        "Não. É uma simulação — os valores só se tornam reais quando o reajuste é efetivamente aplicado fora desta ferramenta pelo time de RH/Financeiro.",
    },
  ],
};

export default simuladorFolha;
